import dynamic from 'next/dynamic';

export const CitySelect: any = dynamic(() => import('./index-es').then(m => m.default));

export default CitySelect;
